import { Box } from "@mui/material";
import { formatLabel } from "@/utils/format-label";

const FALLBACK = { bg: "#f3f4f6", color: "#374151", dot: "#9ca3af" };

const CustomStatusChip = ({ status, styles = {}, size = "small" }) => {
  const style = styles[status] ?? FALLBACK;
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: size === "small" ? 1.25 : 1.5,
        py: 0.5,
        borderRadius: "999px",
        backgroundColor: style.bg,
        color: style.color,
        fontSize: size === "small" ? "0.75rem" : "0.8rem",
        fontWeight: 500,
        whiteSpace: "nowrap",
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: style.dot }} />
      {formatLabel(status ?? "UNKNOWN")}
    </Box>
  );
};

export default CustomStatusChip;